<template>
    <div id="top-footer">
        <div class="container">
            <div class="grid-row space-between">
                <div class="c-2 c-sm-6 c-xs-6">
                    <div class="top-footer-element">
                        <div class="top-footer-element-img">
                            <img src="../../assets/img/topfooter/quality.png" />
                        </div>
                        <span>{{$_('quality')}}</span>
                    </div>
                </div>
                <div class="c-2 c-sm-6 c-xs-6">
                    <div class="top-footer-element">
                        <div class="top-footer-element-img guidance">
                            <img src="../../assets/img/topfooter/guidance.png" />
                        </div>
                        <span>{{$_('technical_advice')}}</span>
                    </div>             
                </div>
                <div class="c-2 c-sm-6 c-xs-6">
                    <div class="top-footer-element">
                        <div class="top-footer-element-img choice">
                            <img src="../../assets/img/topfooter/choice.png" />
                        </div>
                        <span>{{$_('large_choice')}}</span>
                    </div>
                </div>
                <div class="c-2 c-sm-6 c-xs-6">
                    <div class="top-footer-element">
                        <div class="top-footer-element-img sav">
                            <img src="../../assets/img/topfooter/sav.png" />
                        </div>
                        <span>{{$_('after_sale')}}</span>
                    </div>
                </div>
                <div class="c-2 c-sm-6 c-xs-12">
                    <div class="top-footer-element">
                        <div class="top-footer-element-img privacy">
                            <img src="../../assets/img/topfooter/privacy.png" />
                        </div>
                        <span>{{$_('dedicated_service')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
#top-footer {
    background-color: #f5f5f5;
    padding: 30px;
}

#top-footer .top-footer-element {
    text-align: center;
    flex-direction: column;
    align-items: center;
}

#top-footer .top-footer-element-img {
    width: 40px;
    margin: auto;
}

#top-footer .top-footer-element-img.choice {  
    width: 85px;
}

#top-footer .top-footer-element-img.sav {
    width: 52px;
}

#top-footer .top-footer-element-img.privacy {
    width: 34px;
}

#top-footer .top-footer-element-img.guidance {
    width: 48px;
}

#top-footer .top-footer-element img {

    display: block;
    margin: auto;
    width: 100%;
    margin-bottom: 25px;
}

#top-footer .top-footer-element span {
    font-size: var(--fz-md);
}

</style>